import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { loginUser } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm] = useState({ usernameOrEmail: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await loginUser(form);
      login(res.data);
      if (res.data.role === 'ADMIN' || res.data.role === 'STAFF') {
        navigate('/admin');
      } else {
        navigate('/member/dashboard');
      }
    } catch (err) {
      setError('Invalid username/email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader eyebrow="Member Login" title="Welcome Back" />
      <section className="section">
        <div className="container" style={{ maxWidth: 420 }}>
          <div className="card">
            {error && <p className="error-text" style={{ marginBottom: 16 }}>{error}</p>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Username or Email</label>
                <input
                  required
                  value={form.usernameOrEmail}
                  onChange={(e) => setForm({ ...form, usernameOrEmail: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  required
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                />
              </div>
              <button type="submit" className="btn btn-gold btn-block" disabled={loading}>
                {loading ? 'Logging in...' : 'Login'}
              </button>
              <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.9rem' }}>
                <Link to="/forgot-password" style={{ color: 'var(--color-gold)', fontWeight: 600 }}>Forgot your password?</Link>
              </p>
              <p style={{ textAlign: 'center', marginTop: 8, fontSize: '0.9rem' }}>
                Not a member yet? <Link to="/register" style={{ color: 'var(--color-gold)', fontWeight: 600 }}>Register here</Link>
              </p>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
